import { render, staticRenderFns } from "./ChangeReqBtn.vue?vue&type=template&id=1f32456e&scoped=true"
import script from "./ChangeReqBtn.vue?vue&type=script&lang=js"
export * from "./ChangeReqBtn.vue?vue&type=script&lang=js"
import style0 from "./ChangeReqBtn.vue?vue&type=style&index=0&id=1f32456e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32456e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
